var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_132_460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 34.125C27.5772 34.125 34.125 27.5772 34.125 19.5C34.125 11.4228 27.5772 4.875 19.5 4.875C11.4228 4.875 4.875 11.4228 4.875 19.5C4.875 27.5772 11.4228 34.125 19.5 34.125Z",
    stroke: "#42296E",
    strokeWidth: 2.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 24.375C22.8655 24.375 25.5938 21.6467 25.5938 18.2812C25.5938 14.9158 22.8655 12.1875 19.5 12.1875C16.1345 12.1875 13.4062 14.9158 13.4062 18.2812C13.4062 21.6467 16.1345 24.375 19.5 24.375Z",
    stroke: "#42296E",
    strokeWidth: 2.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71948 30.3773C10.6365 28.5712 12.0357 27.0542 13.762 25.9946C15.4883 24.935 17.4744 24.3741 19.5 24.3741C21.5255 24.3741 23.5116 24.935 25.2379 25.9946C26.9642 27.0542 28.3634 28.5712 29.2804 30.3773",
    stroke: "#42296E",
    strokeWidth: 2.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_132_460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "#42296E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSettingsIcon);
export default __webpack_public_path__ + "static/media/user_settings_icon.00a96e1df4af8ecb4a0140891b2b2e22.svg";
export { ForwardRef as ReactComponent };